import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "9fff46b5-baad-4fa4-838a-ce7abfea979a",
  publicId: "14",
  name: "Hearing Models",
  difficulty: 3,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, task01],
};

export default lesson;
